export default {
      id: "i-vkontakte-usage",
      viewBox: "0 0 20 12",
      url: __webpack_public_path__ + "img/sprite.svg#i-vkontakte",
      toString: function () {
        return this.url;
      }
    }